import { render, staticRenderFns } from "./ChartColumn.vue?vue&type=template&id=04395629"
import script from "./ChartColumn.vue?vue&type=script&lang=js"
export * from "./ChartColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports